import { SimpleTabsProvider } from 'contexts/SimpleTabsContext';

import ProviderPlanning from '../context/ContextPrevision';
import { SCREEN_TYPE_TO_ENUM_MAPPING } from '../context/types/contextPrevision.type';

export default function RegisterConsensus() {
	return (
		<SimpleTabsProvider>
			<ProviderPlanning
				screenType={SCREEN_TYPE_TO_ENUM_MAPPING.CONSENSUS}
			/>
		</SimpleTabsProvider>
	);
}
